import { render, staticRenderFns } from "./SystemicTherapy.vue?vue&type=template&id=a9a4ab10&"
import script from "./SystemicTherapy.vue?vue&type=script&lang=js&"
export * from "./SystemicTherapy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports